import { Spark } from "./Logo";

const ITEMS = [
  "What to do",
  "Who to go with",
  "How to get in",
  "Mobile-first discovery",
  "Social layer",
  "Boston only",
  "Stagehands & crew",
  "Production companies",
];

const Track = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl font-bold uppercase tracking-wide text-brand-mist/35 sm:text-3xl">
          {item}
        </span>
        <Spark className="h-4 w-4 shrink-0 text-brand-gold/60" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section className="relative border-y border-brand-purple/15 bg-[#07030f] py-8" data-testid="marquee-section">
      <div className="group flex overflow-hidden">
        <div className="flex animate-[marquee-drift_44s_linear_infinite] group-hover:[animation-play-state:paused]">
          <Track />
          <Track hidden />
        </div>
      </div>
    </section>
  );
}
